import React from "react";
import CourseDetailTemplate from "./CourseDetailTemplate";
const CURRICULUM = [
  "Cloud Computing Fundamentals",
  "AWS Core Services (EC2, S3, RDS, Lambda)",
  "Networking and Security in AWS",
  "Deployment and Management",
  "Cost Management Strategies",
  "Hands-on with EC2, S3, and RDS",
  "Real-world Projects and Case Studies",
];
const STRUCTURE = [
  { title: "Admission",                      desc: "Eligibility check and onboarding process." },
  { title: "Training / Learning — 3 Months", desc: "Intensive cloud training with expert mentors." },
  { title: "Certification Preparation",      desc: "Exam prep for AWS certification exams." },
  { title: "Live Projects & Case Studies",   desc: "Build and deploy real AWS solutions." },
  { title: "Monthly Assessment & Feedback",  desc: "Track progress with regular evaluations." },
  { title: "Certification & Job Support",    desc: "Industry-recognised AWS certification." },
];
const AWS = () => (
  <CourseDetailTemplate title="AWS Certification Course"
    description="Become a certified AWS expert and enhance your cloud skills! Learn cloud computing, architecture, and deployment strategies. Boost your career with hands-on projects and industry-relevant knowledge."
    curriculum={CURRICULUM} structure={STRUCTURE}
    tags={["AWS", "EC2", "S3", "Lambda", "Cloud Architecture"]}
    programName="AWS Certification Course"
  />
);
export default AWS;
